import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum GoldenDomeNotificationType {
  SLACK = "SLACK",
}

const notificationSentSchema_ = z.object({
  timestamp: z.date(),
  teamId: z.string(),
  appId: z.string(),
});

const goldenDomeNotificationSchema_ = z.object({
  _id: zExt.objectId(),
  userEmail: z.string(),
  appIds: z.array(z.string()),
  notificationsSent: z.array(notificationSentSchema_),
  title: z.string(),
  customMessage: z.string().optional(),
  notificationType: createEnum(GoldenDomeNotificationType, {
    enumName: "golden_dome_notification_type",
  }),
  includeAppInstallationRemoved: z.boolean().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const GoldenDomeNotificationSchema: z.ZodType<GoldenDomeNotification> =
  goldenDomeNotificationSchema_;
export interface GoldenDomeNotification
  extends z.infer<typeof goldenDomeNotificationSchema_> {}
